import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface SettingsStore {
  razorpay: {
    keyId: string;
    keySecret: string;
  };
  updateRazorpaySettings: (settings: { keyId: string; keySecret: string }) => void;
}

const initialState = {
  razorpay: {
    keyId: 'rzp_test_vmJG00z8Ft0Oto',
    keySecret: 'egsiIm9iAbikw0Tc9eT15q2Y',
  },
};

export const useSettingsStore = create<SettingsStore>()(
  persist(
    (set) => ({
      ...initialState,
      updateRazorpaySettings: (settings) =>
        set((state) => ({
          razorpay: { ...state.razorpay, ...settings },
        })),
    }),
    {
      name: 'settings-store',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        razorpay: state.razorpay,
      }),
      version: 2,
      migrate: (persistedState: any, version: number) => {
        if (version === 1) {
          return {
            ...initialState,
            ...persistedState,
          };
        }
        return persistedState;
      },
    }
  )
);